<div [formGroup]="orderForm" [hidden]="!loaded">
  <div class="access-container">
    <div class="access-form-entry">
      <div class="form-entry-title" translate>ACCESSCONFIG_MECHCODE</div>
      <mat-form-field appearance="outline">
        <input matInput matNativeControl class="form-input" type="text" autocomplete="off" spellcheck="false"
          formControlName="mechCode" placeholder="{{ 'ACCESSCONFIG_MECHCODE_PLACEHOLDER' | translate }}"
          style="text-transform: uppercase" />
      </mat-form-field>
      @if (orderForm.get('mechCode')?.errors?.['pattern']) {
      <mat-error class="form-entry-error" translate>INVALID_MECHCODE_FORMAT</mat-error>
      }
    </div>
    <!-- TIPO UTENTE -->
    <div class="access-form-entry">
      <div class="form-entry-title" translate>IC_USER_TYPE_TITLE</div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="selectUserType">
          @for(ut of userTypes; track ut;) {
          <mat-option [value]="ut.value">
            {{ ut.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <!-- PIANO -->
    <div class="access-form-entry">
      <div class="form-entry-title" translate>ACCESSCONFIG_PLAN</div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="planId" class="form-select">
          @for (p of planIds; track p) {
          <mat-option [value]="p.id">
            {{ p.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <!-- CREDITI AI -->
    <div class="access-form-entry">
      <div class="form-entry-title" translate>ACCESSCONFIG_CREDITS_AI</div>
      <mat-form-field appearance="outline">
        <input matInput matNativeControl class="form-input" type="number" autocomplete="off" spellcheck="false"
          formControlName="aiCredits" />
      </mat-form-field>
    </div>
    <!-- SCANSIONI OCR MATEMATICO -->
    @if (orderForm.get('planId')?.value === 'full') {
    <div class="access-form-entry">
      <div class="form-entry-title" translate>ACCESSCONFIG_OCR_QUOTA</div>
      <mat-form-field appearance="outline">
        <input matInput matNativeControl class="form-input" type="number" autocomplete="off" spellcheck="false"
          formControlName="ocrMathScanQuota" />
      </mat-form-field>
    </div>
    <div class="access-form-entry">
      <div class="form-entry-title" translate>ACCESSCONFIG_OCR_POLICY</div>
      <mat-form-field appearance="outline">
        <mat-select matNativeControl formControlName="ocrMathScanPolicy" class="form-select">
          @for (s of scanPolicies;track s;) {
          <mat-option [value]="s.id">
            {{ s.name | translate }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    }
    <!-- ACQUIRENTE -->
    <div class="access-form-entry">
      <div class="form-entry-title" translate>ACCESSCONFIG_USER_NAME</div>
      <mat-form-field appearance="outline">
        <input matInput matNativeControl class="form-input" type="text"
          placeholder="{{ 'ACCESSCONFIG_USER_NAME_PLACEHOLDER' | translate }}" autocomplete="off" spellcheck="false"
          formControlName="fullName" />
      </mat-form-field>
      @if ( f.fullName.errors && f.fullName.errors['required']) {

      <mat-error class="form-entry-error" translate> FIELD_REQUIRED </mat-error>
      }
    </div>
    <!-- EMAIL -->
    <div class="access-form-entry">
      <div class="form-entry-title" translate>
        ACCESSCONFIG_USERS_PLACEHOLDER
      </div>
      <mat-form-field appearance="outline">
        <input matNativeControl matInput class="form-input" type="text"
          placeholder="{{ 'ACCESSCONFIG_USERS_PLACEHOLDER' | translate }}" autocomplete="off" spellcheck="false"
          formControlName="userEmail" />
      </mat-form-field>
      @if (f.userEmail.errors && f.userEmail.errors['required']) {
      <mat-error translate> FIELD_REQUIRED </mat-error>
      } @if (f.userEmail.errors && f.userEmail.errors['email']) {
      <mat-error translate> NOT_VALID_EMAIL_MSG </mat-error>
      }
    </div>
    <!-- START DATE -->
    <div class="access-form-entry">
      <div class="form-entry-title" translate>START_DATE</div>
      <div>
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="startDate" autocomplete="off" spellcheck="false" formControlName="startDate"
            readonly />
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker #startDate></mat-datepicker>
        </mat-form-field>
      </div>
      @if (f.expireDate.errors && f.expireDate.errors['required']) {
      <mat-error translate> FIELD_REQUIRED </mat-error>
      }
    </div>
    <!-- EXPIRE DATE -->
    <div class="access-form-entry">
      <div class="form-entry-title" translate>EXPIRE_DATE</div>
      <div>
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="expireDate" autocomplete="off" spellcheck="false"
            formControlName="expireDate" readonly />
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="expireDate"></mat-datepicker-toggle>
          <mat-datepicker #expireDate></mat-datepicker>
        </mat-form-field>
      </div>
      @if (f.expireDate.errors && f.expireDate.errors['required']) {

      <mat-error translate> FIELD_REQUIRED </mat-error>
      }
    </div>
  </div>
  <!-- ORDER ORIGIN -->
  <div class="access-form-entry">
    <div class="form-entry-title" translate>ORDER-ORIGIN</div>
    <mat-form-field appearance="outline">
      <mat-select class="form-select" formControlName="origin">
        @for (o of origins; track o) {
        <mat-option [value]="o.id">
          {{ o.name | translate }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <!--<div class="form-entry-error" translate>FIELD_REQUIRED</div>-->
  </div>
  <!-- SUSPEND SUBSCRIPTION -->
  <div class="access-form-entry">
    <div class="form-entry-title" translate>SUSPEND_SUBSCRIPTION</div>
    <div>
      <mat-slide-toggle class="form-checkbox" formControlName="suspended"></mat-slide-toggle>
      <!--<input class="form-checkbox" type="checkbox" autocomplete="off" formControlName="suspended" />-->
    </div>
    <!--<div class="form-entry-error" translate>FIELD_REQUIRED</div>-->
  </div>
  <!-- SUBSCRIPTION NOTES-->
  <div class="access-form-entry">
    <div class="form-entry-title" translate>SUBSCRIPTION_NOTES</div>
    <mat-form-field appearance="outline">
      <textarea matInput class="form-textarea" formControlName="notes"></textarea>
    </mat-form-field>
    <!--<div class="form-entry-error" translate>FIELD_REQUIRED</div>-->
  </div>
  <!-- ACCESS SLOTS -->
  @if (showSlot) {

  <div class="access-form-entry">
    <div class="form-entry-title" translate>ACCESSCONFIG_SLOTS</div>
    <mat-form-field appearance="outline">
      <input matInput class="form-input" type="number" autocomplete="off" spellcheck="false"
        formControlName="slotCount" />
    </mat-form-field>
    <!--<div class="form-entry-error" translate>FIELD_REQUIRED</div>-->
  </div>

  }
  <!-- UTENZE DOMINIO -->
  @if (showDomainLics) {

  <div class="access-form-entry">
    <div class="form-entry-title" translate>ACCESSCONFIG_DOMAINLICS</div>
    <mat-form-field appearance="outline">
      <input matInput class="form-input" type="number" autocomplete="off" spellcheck="false"
        formControlName="domainLics" />
    </mat-form-field>
    <div class="form-entry-description" translate>
      ACCESSCONFIG_DOMAINLICS_DESC
    </div>
    @if (showSlot && f.slotCount.errors) {
    <mat-error translate> FIELD_REQUIRED </mat-error>
    } @if (showSlot && orderForm.get('slotCount')?.errors?.['min']) {
    <mat-error translate> MIN_ERROR </mat-error>
    } @if (showSlot && orderForm.get('slotCount')?.errors?.['max']) {
    <mat-error translate> MAX_ERROR </mat-error>
    }
  </div>

  }
</div>